import { render, staticRenderFns } from "./StaticPagesHeader.vue?vue&type=template&id=6a0d60a7&scoped=true"
import script from "./StaticPagesHeader.vue?vue&type=script&lang=js"
export * from "./StaticPagesHeader.vue?vue&type=script&lang=js"
import style0 from "./StaticPagesHeader.vue?vue&type=style&index=0&id=6a0d60a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d60a7",
  null
  
)

export default component.exports